import { get, patch } from './index';
import qs from 'qs';

// Per-night rate / minimum-stay overrides for a hotel, grouped by room.
// `hotelId` must be the RAW numeric id (decode any idService-encoded id before
// calling); the endpoint binds it as a plain numeric route param. Only nights
// carrying an override are returned — the caller overlays them on the period grid.
export const getHotelNightRates = async ({
  hotelId,
  from,
  to,
  roomId,
  organizationId,
}) => {
  const query = qs.stringify(
    {
      from,
      to,
      ...(roomId ? { roomId } : {}),
      ...(organizationId ? { organizationId } : {}),
    },
    { skipNulls: true },
  );
  return get(`/hotels/${hotelId}/night-rates?${query}`);
};

// Upsert / clear per-night overrides. `payload` is an array of
// `{ id: roomId, organizationId, nights: [{ day, periodId, fitPrice?, minimumStay? }] }`, where
// `periodId` is the RAW period id and a night with every axis null clears the
// override back to its period default.
export const updateHotelNightRates = async ({ hotelId, payload }) => {
  return patch(`/hotels/${hotelId}/night-rates`, payload);
};
